import {
  Text,
  useToast as useChakraToast,
  UseToastOptions,
} from '@chakra-ui/react'

export const useToast = () => {
  const toast = useChakraToast()
  return ({ status, description, title, id, ...rest }: UseToastOptions) => {
    if (!toast.isActive(`${id}`)) {
      toast({
        title:
          title === undefined && status !== undefined
            ? status[0].toUpperCase() + status.substring(1)
            : title,
        status,
        description: Array.isArray(description)
          ? description.map((m, index) => (
              <Text key={index} fontSize="sm">
                {m}
              </Text>
            ))
          : description,
        duration: 5000,
        isClosable: true,
        position: 'top',
        id: id,
        ...rest,
      })
    }
  }
}

export default useToast
